import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { geoFromIP } from 'utils/bolt/geo';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';

// including US and CA  as they need the cookies modal too
const gdprRegions = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se', 'gb', 'us', 'ca'];

class StaticButton extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <button type="button" {...props} />;
	}
}

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		if (gdprRegions.includes(geo?.countryCode)) {
			this.setState({ gdprRegion: true });
		}
		// const usingKetch = this.props.store?.appData?.options?.ketchCookieConsent?.scripts;
		// if (usingKetch) {
		// 	this.updateketchCookiePreferencesText();
		// }
	}

	componentDidUpdate(prevProps, prevState) {
		const usingKetch = this.props.store?.appData?.options?.ketchCookieConsent?.scripts;
		if (usingKetch && !prevState.gdprRegion && this.state.gdprRegion) {
			// Update the cookie preferences text (if it's already been rendered, otherwise it will happen when ready)
			window?.cbsoptanon?.cmd?.push(cmp => cmp?.UserInterface?.MenuText?.state?.rendered && cmp.UserInterface.MenuText.render());
		}
	}

	// Should not be necessary since MenuText.render in componentDidUpdate should automatically replace .ot-sdk-show-settings
	// async updateketchCookiePreferencesText() {
	// 	try {
	// 		const [consentData, textData] = await Promise.all([
	// 			'CONSENT_READY',
	// 			'NETWORK_LEGAL_MENU_TEXT_LOADED',
	// 		].map(evt => new Promise(res => {
	// 			// Should we reject on a timeout to clear memory?
	// 			window?.cbsoptanon?.Configuration?.EventManager?.addEventListener(
	// 				window?.cbsoptanon?.constants?.EVENTS?.[evt],
	// 				e => res(e.detail)
	// 			);
	// 		})));
	// 		const pref = textData.preferences[consentData.consentModel] || textData.preferences.default;
	// 		const language = navigator.language.toLowerCase();
	// 		const text = pref[language] || pref[language.slice(0, 2)] || pref.en;
	// 		if (text) {
	// 			this.setState({ ketchPreferencesText: text });
	// 		}
	// 	} catch {}
	// }

	renderLinks(items, type) {
		const base = super.renderLinks(items, type);
		const usingOneTrust = accessNested(this.props, 'store.appData.options.oneTrustCookieConsent.scripts');
		const usingKetch = accessNested(this.props, 'store.appData.options.ketchCookieConsent.scripts');

		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		const underAge = ageGateEnabled && !isOfAge;

		if (type !== 'link' || (!usingKetch && !usingOneTrust) || underAge || !this.state.gdprRegion) {
			return base;
		}

		if (this.props.store?.appData?.footer?.defaultFooter?.noParamountExtraLink) {
			return base;
		}

		if (usingOneTrust) {
			let cookieLinkText = 'Your Privacy Choices';

			if (typeof window !== 'undefined') {
				cookieLinkText = window.OneTrust?.GetDomainData?.()?.AlertMoreInfoText || 'Your Privacy Choices';
			}

			return [].concat(base, (
				<li class={s.linkWrapper} key="onetrust-manage-cookies">
					<StaticButton
						class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
						role="button"
						onClick={() => window.OneTrust?.ToggleInfoDisplay()}
					>
						{cookieLinkText}
					</StaticButton>
				</li>
			));
		}


		return [].concat(base, (
			<li class={s.linkWrapper} key="ketch-manage-cookies">
				<StaticButton
					class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
					onClick={() => window.ketch('showPreferences')}
				>
					{this.state.ketchPreferencesText || 'Your Privacy Choices'}
				</StaticButton>
			</li>
		));
	}
}
